export enum E_ANALYSIS_CHART {
  PAPER_TRENDS_BAR = 'paper_datetime_ts',
  PATENT_TRENDS_BAR = 'apd_y_issued',
  PATENT_MATRIX = 'key_benefit_phrase_adc_c',
  WORD_CLOUD = 'tech_domain_word_cloud',
  KEY_BENEFIT_PHRASE_ADC_C = 'key_benefit_phrase_adc_c',
  BENEFIT_PHRASE_ADC_C = 'benefit_phrase_adc_c',
  TECH_DOMAIN_WORD_CLOUD = 'tech_domain_word_cloud',
  APD_Y_ISSUED = 'apd_y_issued',
  PAPER_DATETIME_TS = 'paper_datetime_ts',

  CO_RESEARCH_GRAPH = 'ancs_id_co_research',
  CO_ASSIGNEE_GRAPH = 'ancs_id_co_assignee',
  TECH_FORWARD_GRAPH = 'cite_tech_topic_ancs_id',
  TECH_BACKWARD_GRAPH = 'cited_tech_topic_ancs_id'
}
export enum E_CHART_TYPE {
  GRAPH = 'graph',
  BAR = 'bar'
}

export enum PATENT_EFFICIENCY_TYPE {
    KEY_EFFICIENCY = 'keyEfficiency',
    ALL_EFFICIENCY = 'allEfficiency'
}

/**
 * 打开弹窗时，需要传递的数据
 */
export interface IRightListComponentData {
    company_id?: string
    chart_type?: E_ANALYSIS_CHART
    include_children?: boolean
    dimension_list?: {
        field: string
        value: string
    }[]
    solution_ids?: string[]
}

export interface IRightListRequest extends IRightListComponentData {
    page: number
    limit: number
}

export interface IDataParam {
    child: boolean
    company_id: string
}

export interface IChartData {
    dimensions: string[]
    source: Record<string, unknown>[]
    extra?: Record<string, unknown>
    total?: Record<string, unknown>
}

export interface IChartResponse {
    TARGET_PATENT_COUNT: IChartData
}

export interface IWhatsNewResponse {
  patent_ids?: string[]
  content: string
  title: string
}

export interface IChartPatentResponse {
  TARGET_PATENT_COUNT: IChartData;
  TARGET_PAPER_COUNT: IChartData;
}

export interface IChartBasicData {
  dimensions: [
    {
      [key: string]: string[];
    }
  ];
  source: [
    {
      [key: string]: number | string;
    }
  ];
  extra: {
    [key: string]: {
      type: string;
      code: string;
      label: string;
      original_name: string;
    }[];
  };
}

export enum E_CO_OPERATE_TAB_TYPE {
    ASSIGNEE = 'assignee',
    RESEARCH = 'research'
}

export enum E_TECH_TAB_TYPE {
  TECH_FORWARD = 'techForward',
  TECH_BACKWARD = 'techBackward'
}
export interface ICompanyBasicData {
  code: string;
  original_name: string;
  label: string;
  type: string;
  logo: string;
  country_name: string;
  company_id: string;
}
export enum E_RM_ACTION {
  RE_LAYOUT = 'RE_LAYOUT',
  RE_LOCATE = 'RE_LOCATE',
  ZOOM_OUT = 'ZOOM_OUT',
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_100 = 'ZOOM_100'
}
export const ZOOM_RANGE = [
    [0.2, 0.25],
    [0.25, 0.5],
    [0.5, 0.75],
    [0.75, 1],
    [1, 1.25],
    [1.25, 1.5],
    [1.5, 2],
    [2, 2.5]
];
/**
 * 图表最小缩放比例尺
 */
export const GRAPH_MIN_ZOOM = 0.02
/**
 * 图表最大缩放比例尺
 */
export const GRAPH_MAX_ZOOM = 2.5
/**
 * 缩放组件能缩放的最小比例尺
 */
export const MIN_ZOOM = 0.2
/**
 * 缩放组件能缩放的最大比例尺
 */
export const MAX_ZOOM = 2.5

export interface ICompanyTopicInfo
{
  id: string;
  name: string;
  count: number;
}

export interface IFormattedZoom {
  icon: string;
  action: () => void;
  name: any;
  width?: undefined;
  text?: undefined;
}

export enum ESearchField {
  ONE_ID = 'ANCS_ORG_ID_ONEID',
  TREE_COMPANY = 'VF_ANCS'
}

export enum E_CHART_FIELD {
  ANCS_ID = 'ANCS_ID',
  MASTER_AFFILIATION_ID = 'master_affiliation_id',
  TTC_CLUSTER_LC = 'TTC_CLUSTER_LC'
}
